"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const client_1 = require("react-dom/client");
const react_router_dom_1 = require("react-router-dom");
const ErrorPage_1 = __importDefault(require("@/ErrorPage"));
const AppLayout_1 = __importDefault(require("@/pages/AppLayout"));
const HomePage_1 = __importDefault(require("@/pages/home/HomePage"));
const ReportsPage_1 = __importDefault(require("@/pages/reports/ReportsPage"));
const BoersenpreisePage_1 = __importDefault(require("@/pages/reports/boerse/BoersenpreisePage"));
const FlaechenauswertungPage_1 = __importDefault(require("@/pages/reports/flaechen/FlaechenauswertungPage"));
const MarktdatenPage_1 = __importDefault(require("@/pages/reports/marktdaten/MarktdatenPage"));
const MilchanlieferungPage_1 = __importDefault(require("@/pages/reports/milch/MilchanlieferungPage"));
const PreisberichtPage_1 = __importDefault(require("@/pages/reports/preise/PreisberichtPage"));
const InfoPage_1 = __importDefault(require("@/pages/reports/info/InfoPage"));
const DashboardPage_1 = __importDefault(require("@/pages/dashboards/DashboardPage"));
const TestPage_1 = __importDefault(require("@/pages/test/TestPage"));
const MenuContext_1 = require("@/components/menu/MenuContext");
require("@/global.css");
const router = (0, react_router_dom_1.createBrowserRouter)([
    {
        path: "/", element: (0, jsx_runtime_1.jsx)(AppLayout_1.default, {}), errorElement: (0, jsx_runtime_1.jsx)(ErrorPage_1.default, {}),
        children: [
            { index: true, element: (0, jsx_runtime_1.jsx)(HomePage_1.default, {}) },
            {
                path: "reports", element: (0, jsx_runtime_1.jsx)(ReportsPage_1.default, {}),
                children: [
                    { index: true, element: (0, jsx_runtime_1.jsx)(MarktdatenPage_1.default, {}) },
                    { path: "marktdaten", element: (0, jsx_runtime_1.jsx)(MarktdatenPage_1.default, {}) },
                    { path: "flaechen", element: (0, jsx_runtime_1.jsx)(FlaechenauswertungPage_1.default, {}) },
                    { path: "preise", element: (0, jsx_runtime_1.jsx)(PreisberichtPage_1.default, {}) },
                    { path: "milch", element: (0, jsx_runtime_1.jsx)(MilchanlieferungPage_1.default, {}) },
                    { path: "boerse", element: (0, jsx_runtime_1.jsx)(BoersenpreisePage_1.default, {}) },
                    { path: "info", element: (0, jsx_runtime_1.jsx)(InfoPage_1.default, {}) },
                    //{ path: "markt/:bookmarkId", element: <MarktdatenPage /> },
                ]
            },
            { path: "dashboards", element: (0, jsx_runtime_1.jsx)(DashboardPage_1.default, {}) },
            { path: "test", element: (0, jsx_runtime_1.jsx)(TestPage_1.default, {}) },
        ],
    },
]);
(0, client_1.createRoot)(document.getElementById("root")).render((0, jsx_runtime_1.jsx)(react_1.StrictMode, { children: (0, jsx_runtime_1.jsx)(MenuContext_1.MenuProvider, { children: (0, jsx_runtime_1.jsx)(react_router_dom_1.RouterProvider, { router: router }) }) }));
